<template>
  <div>
    <Layout>
      <ChiWarning
        type="danger"
        :text="`Message from CHI: ${this.$store.state.user.messageToHF}`"
        title="Unfortunately your interest request had to be cancelled."
        v-if="this.$store.state.user.messageToHF"
      >
        <p>Your last interest request was cancelled by CHI, because:</p>
        <p>{{ this.$store.state.user.messageToHF }}</p>
      </ChiWarning>
      <ChiCard v-if="this.getApplicationLevel() < 5">
        <div
          class="-mx-12 -mt-12 px-6 py-4 border-b border-purple-ap-t03 flex flex-col lg:flex-row justify-between items-center"
        >
          <h2 class="mb-3 lg:mb-0">Welcome, {{ userName }}</h2>
          <router-link :to="{ name: 'UserProfile' }">
            <i class="align-text-bottom material-icons">account_box</i>
            Edit My Details
          </router-link>
        </div>

        <div class="my-10">
          <p class="text-center font-regular mb-5">
            The CHI Au Pair dashboard makes it easy for you to view Available Au
            Pairs, compare your favorite selections, interview candidates, show
            interest in Au Pairs and complete your initial application.
          </p>

          <p class="text-center font-regular mb-5">
            Each step will become available as you progress towards finding the
            ideal childcare program.
            <br /><strong
              >And remember, you can always call or email our experienced and
              caring customer service team.</strong
            >
          </p>
        </div>

        <div class="-mx-12 px-5 -mb-5">
          <div class="steps-container">
            <!-- new user or a user with no au pairs in the favortites list -->
            <ChiApplicationStep
              step="1"
              to="AvailableAuPairs"
              imageSrc="AvailableAuPairs.jpg"
              title="View available Au Pairs and pick your favorites"
            />

            <!-- user with au pairs on favorites, but no interview requested  -->
            <ChiApplicationStep
              step="2"
              to="FavoriteAuPairs"
              imageSrc="FavoriteAuPairs.jpg"
              title="Compare your favorite Au Pairs and schedule interviews"
            />

            <!-- user with interview requests but no match -->
            <ChiApplicationStep
              step="3"
              to="RequestInterview"
              imageSrc="Interview.jpg"
              title="Complete your interviews and show interest in your preferred Au Pair"
            />

            <!-- complete your application-->
            <ChiApplicationStep
              step="4"
              to="Matches"
              imageSrc="Match.jpg"
              title="Complete your initial Au Pair request application"
            />
          </div>
        </div>
      </ChiCard>

      <div v-else>
        <ChiCard>
          <h3 class="text-center text-purple-ap-100 font-light text-4xl mb-10">
            Your application will be reviewed by the CHI Au Pair Department
            shortly.
          </h3>

          <p class="text-center">
            Once your request is approved, you will be able to choose your
            payment plan, submit your payment online, run your criminal
            background check and sign the program contract.
          </p>
        </ChiCard>
        <ChiCard v-if="aupair">
          <h3
            class="my-10 text-center text-4xl font-semibold uppercase text-purple-ap-100"
          >
            Your Au Pair
          </h3>

          <div class="lg:px-6">
            <ProfileContainer :aupair="aupair" />
          </div>
        </ChiCard>
        <ComponentLoading v-else />
      </div>
    </Layout>
    <FinderCTA />
  </div>
</template>

<script>
import ProfileContainer from "@/components/AuPairs/AuPairProfileItems/ProfileContainer.vue";

import ChiCard from "@/components/UI/ChiCard.vue";
import ChiApplicationStep from "@/components/UI/ChiApplicationStep.vue";
import Layout from "@/Layout/Authenticated/Layout.vue";
import FinderCTA from "@/components/Finder/FinderCTA.vue";
import ChiWarning from "@/components/UI/ChiWarning.vue";

import { api } from "@/services.js";
import { getApplicationLevel } from "@/helpers.js";

export default {
  name: "Dashboard",
  components: {
    ChiCard,
    ChiApplicationStep,
    ProfileContainer,
    ChiWarning,
    FinderCTA,
    Layout,
  },
  data() {
    return {
      completed: this.$store.state.user.match,
      aupair: null,
    };
  },
  created() {
    if (this.completed) {
      api
        .get(`/promotional/AuPairPromoProfiles/${this.completed}`)
        .then((r) => {
          this.aupair = r.data;
        });
    }
  },

  methods: {
    getApplicationLevel() {
      return getApplicationLevel(this.$store.state.user);
    },
  },
  computed: {
    userName() {
      return `${this.$store.state.user.firstName} ${this.$store.state.user.lastName}`;
    },
    profilePhoto() {
      return `https://ap2.chinet.org/api/v1.0${this.aupair.profilePhoto}/sm`;
    },
  },
};
</script>

<style scoped>
.steps-container {
  min-height: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.steps-container > div {
  display: flex;
  flex-basis: calc(50% - 20px);
  justify-content: center;
  flex-direction: column;
  margin: 10px 0;
}

@media only screen and (max-width: 767px) {
  .steps-container {
    flex-direction: column;
  }
  .steps-container > div {
    margin: 20px 0;
  }
}
</style>
